import moment, { min } from "moment";
import { Dialog } from "@mui/material";
import { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TopBar } from "../components/topBar";
import Snackbar from "@mui/material/Snackbar";
import Button from "@mui/material/Button";
import "swiper/css";
import backwardArrow from "../assets/icons/backwardArrow.svg";
import arrow from "../assets/icons/arrow.svg";
import { FootMenu } from "../components/FootMenu";
import { GetCorporation, GetCorporationInput, useGetCorporation } from "../hooks/useGetCorporation";
import { MeQuery } from "../gql/graphql";
import { useListGoodReview } from "../hooks/useListGoodReview";
import { useMe } from "../hooks/useME";
export interface State {
  open: boolean;
}

export const GoodCoporationInfo = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [corporation, setCorporation] = useState<GetCorporation["getCorporation"]["corporation"]>();
  const { data: me } = useMe();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const onGetCorporationCompleted = (data: GetCorporation) => {
    const {
      getCorporation: { ok, err, corporation },
    } = data;
    if (ok && corporation) {
      setCorporation(corporation);
    }
  };
  const [getCorporation, { data: getCorporationData }] =
    useGetCorporation(onGetCorporationCompleted);
  const getCorporationHandler = () => {
    const input: GetCorporationInput = {
      corporationId: Number(params.key),
      userId: me?.me.id ? Number(me.me.id) : 0,
    };
    getCorporation({ variables: { input } });
  };

  useEffect(() => {
    if (params.key) {
      getCorporationHandler();
    }
  }, [params.key]);

  return (
    <div className="h-full relative flex flex-wrap flex-col ">
      <header>
        <TopBar arrow={true} heading={true} shop={true} />
      </header>
      <main className="max-w-screen-break w-full flex-1 mx-auto overflow-auto removeScroll pb-[72px] bg-bg">
        <section
          id="reviewList"
          className="p-4 pb-10  flex flex-wrap flex-col gap-y-4 "
        >
          <div className="w-full flex flex-col gap-y-4">
            {/* 매장정보 */}
            <div className="review border border-btnLightLine rounded-2xl bg-white">
              <div className="h-10 py-2 px-4 text-sm flex flex-wrap content-center ">
                <p className="flex flex-wrap justify-between content-center flex-1 gap-x-1">
                  <span className="font-bold">{`매장정보`}</span>
                </p>
              </div>
              <div className="Box space-y-4 p-4">
                <div className="flex flex-col gap-y-2">
                  <div className={`flex flex-wrap items-start gap-x-4`}>
                    <div className="w-24">
                      <p className="text-sm font-bold">매장명</p>
                    </div>
                    <div className="flex-1 ">
                      <p className="text-small">{corporation?.name}</p>
                    </div>
                  </div>
                  <div className={`flex flex-wrap items-start gap-x-4`}>
                    <div className="w-24">
                      <p className="text-sm font-bold">주소</p>
                    </div>
                    <div className="flex-1 ">
                      <p className="text-small">{corporation?.address}</p>
                    </div>
                  </div>
                  <div className={`flex flex-wrap items-start gap-x-4`}>
                    <div className="w-24">
                      <p className="text-sm font-bold">운영시간</p>
                    </div>
                    <div className="flex-1 ">
                      <p className="text-small whitespace-pre-wrap">{corporation?.operationFrom && corporation?.operationTo ? `${corporation.operationFrom} ~ ${corporation.operationTo}` : ""}</p>
                    </div>
                  </div>
                  <div className={`flex flex-wrap items-start gap-x-4`}>
                    <div className="w-24">
                      <p className="text-sm font-bold">휴무일</p>
                    </div>
                    <div className="flex-1 ">
                      <p className="text-small">{corporation?.holiday ? `${corporation.holiday}` : ""}</p>
                    </div>
                  </div>
                  <div className={`flex flex-wrap items-start gap-x-4`}>
                    <div className="w-24">
                      <p className="text-sm font-bold">전화번호</p>
                    </div>
                    <div className="flex-1 ">
                      <p className="text-small">{corporation?.businessNumber ? `${corporation.businessNumber}` : ""}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* 사업자 정보 표시 */}
            <div className="review border border-btnLightLine rounded-2xl bg-white">
              <div className="h-10 py-2 px-4 text-sm flex flex-wrap content-center ">
                <p className="flex flex-wrap justify-between content-center flex-1 gap-x-1">
                  <span className="font-bold">{`사업자 정보`}</span>
                </p>
              </div>
              <div className="Box space-y-4 p-4">
                <div className="flex flex-col gap-y-2">
                  <div className={`flex flex-wrap items-start gap-x-4`}>
                    <div className="w-24">
                      <p className="text-sm font-bold">대표자</p>
                    </div>
                    <div className="flex-1 ">
                      <p className="text-small">{corporation?.ceoName ? `${corporation.ceoName}` : ""}</p>
                    </div>
                  </div>
                  <div className={`flex flex-wrap items-start gap-x-4`}>
                    <div className="w-24">
                      <p className="text-sm font-bold">상호명</p>
                    </div>
                    <div className="flex-1 ">
                      <p className="text-small">{corporation?.businessName ? `${corporation.businessName}` : ""}</p>
                    </div>
                  </div>
                  <div className={`flex flex-wrap items-start gap-x-4`}>
                    <div className="w-24">
                      <p className="text-sm font-bold">사업자 주소</p>
                    </div>
                    <div className="flex-1 ">
                      <p className="text-small whitespace-pre-wrap">{corporation?.businessAddress ? `${corporation.businessAddress}` : ""}</p>
                    </div>
                  </div>
                  <div className={`flex flex-wrap items-start gap-x-4`}>
                    <div className="w-24">
                      <p className="text-sm font-bold">사업자등록번호</p>
                    </div>
                    <div className="flex-1 ">
                      <p className="text-small">{corporation?.businessNumber ? `${corporation.businessNumber}` : ""}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* 원산지지 표시 */}
            <div className="review border border-btnLightLine rounded-2xl bg-white">
              <div className="h-10 py-2 px-4 text-sm flex flex-wrap content-center ">
                <p className="flex flex-wrap justify-between content-center flex-1 gap-x-1">
                  <span className="font-bold">{`원산지 표기`}</span>
                </p>
              </div>
              <div className="Box space-y-4 p-4">
                <div className="flex flex-col gap-y-2">
                  <div className={`flex flex-wrap items-start gap-x-4`}>
                    <div className="flex-1 ">
                      <p className="text-small">{corporation?.origin ? `${corporation.origin}` : ""}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <FootMenu />
    </div>
  );
};
